import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import Cookies from 'universal-cookie';
import isEmpty from 'lodash/isEmpty';

import GuestLogin from '@/components/GuestLogin/GuestLogin';
import { getCMSHomepageGrid } from '@/api/cms';
import { getOrFetchHeaderData } from '@/utils/headerCalls';
import LoginLayout from '@/components/LoginLayout/LoginLayout';
import { getLayoutProps } from '@/utils/layout/layout';
import { getOrFetchConfiguration } from '@/utils/getConfiguration';

export default function GuestLoginPage({ logo, loginLogo, loginConfig, loginImage, responsiveLogo }) {
  const router = useRouter();
  const [config, setConfig] = useState();

  loginImage === '' ? (loginConfig = 0) : null;
  const cookies = new Cookies();
  const authorization = cookies.get('token');
  useEffect(() => {
    if (!isEmpty(authorization)) {
      router.replace('/');
      return;
    }
  }, []);
  useEffect(() => {
    async function getConfiguration() {
      const configuration = await getOrFetchConfiguration();
      setConfig(configuration);
    }

    getConfiguration();
  }, []);

  if (!isEmpty(authorization)) return null;
  return (
    <>
      <LoginLayout type={loginConfig} image={loginImage} responsiveLogo={responsiveLogo}>
        <GuestLogin logo={loginLogo ? loginLogo : logo} type={loginConfig} config={config} />
      </LoginLayout>
    </>
  );
}

export async function getStaticProps({ locale }) {
  const { responsiveLogo } = await getLayoutProps({ headerProps: { selectedIndex: -1 } }, locale);
  const [{ data: logoData }, { data: loginLogoData }, { data: loginAllData }] = await Promise.all([
    getCMSHomepageGrid('header_logo', locale),
    getOrFetchHeaderData('login_logo', locale),
    getOrFetchHeaderData('login_page', locale),
  ]);
  const logo = logoData.data[0].content.logo.url;
  const loginLogo = loginLogoData.data[0].content.login_logo.url;
  const loginConfig = loginAllData.data[0].content.configuration;
  const loginImage = loginAllData.data[0].content.image?.url ? loginAllData.data[0].content.image?.url : '';

  const messages = {
    common: (await import(`../../../prebuild-data/i18n/${locale}/common.json`)).default,
    guest_login: (await import(`../../../prebuild-data/i18n/${locale}/guest_login.json`)).default,
  };

  return {
    props: {
      responsiveLogo,
      logo,
      loginLogo,
      loginConfig,
      loginImage,
      messages,
    },
  };
}
